import { mat4, vec2 } from "gl-matrix"
import { radians } from "@/core/utils/math"
import { Adjustments } from "@/core/types"

export function getPerspectiveMatrix(
	adjustments: Adjustments,
	initialOrientation: number,
	inputSize: vec2,
) {
	const mat = mat4.create()

	const [iw, ih] = inputSize
	const [ow, oh] = initialOrientation % 2 ? [ih, iw] : [iw, ih]

	// Orientation
	const orientationRadian = radians(initialOrientation * 90)
	if (orientationRadian) {
		mat4.rotateZ(mat, mat, -orientationRadian)
	}

	// Perspective (horizontal + vertical)
	mat4.rotateX(mat, mat, -radians((adjustments.perspectiveVertical * -45) / 2))
	mat4.rotateY(mat, mat, radians((adjustments.perspectiveHorizontal * -45) / 2))

	// Perspective rotate
	mat4.scale(mat, mat, [1 / ow, 1 / oh, 1])
	mat4.rotateZ(mat, mat, -radians(adjustments.perspectiveRotate))
	mat4.scale(mat, mat, [ow, oh, 1])

	// Perspective (scale + aspect)
	const aspectOffset = adjustments.perspectiveAspect / 10
	mat4.scale(mat, mat, [
		1 / adjustments.perspectiveScale + aspectOffset,
		1 / adjustments.perspectiveScale - aspectOffset,
		1,
	])

	// Perspective offset
	const offsetLimit = 5 / 6
	mat4.translate(mat, mat, [
		-adjustments.perspectiveOffsetX * 2 * offsetLimit,
		adjustments.perspectiveOffsetY * 2 * offsetLimit,
		0,
	])

	// Orientation back
	if (orientationRadian) {
		mat4.rotateZ(mat, mat, orientationRadian)
	}

	return mat
}
